import * as Yup from "yup";

export const FormQueryPricesValidationSchema = Yup.object().shape({
  CNPJ: Yup.string().required("Selecione um CNPJ"),
  freightType: Yup.string()
    .oneOf(["CIF", "FOB"], "Selecione um tipo de frete")
    .required("Selecione um tipo de frete"),
  filialID: Yup.string().required("Selecione uma filial"),
  withdrawBasisID: Yup.string().required("Selecione uma base de retirada"),
  address: Yup.object().nullable().required("Selecione um endereço"),
});
